module.exports = __webpack_public_path__ + "img/outside-temperature-md.14a2f008.svg";